module.exports = __webpack_public_path__ + "img/NLD.b5f02180.svg";